/*
 * Licensed to Elasticsearch B.V. under one or more contributor
 * license agreements. See the NOTICE file distributed with
 * this work for additional information regarding copyright
 * ownership. Elasticsearch B.V. licenses this file to you under
 * the Apache License, Version 2.0 (the "License"); you may
 * not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import React from 'react';
import PropTypes from "prop-types";
import classNames from 'classnames';
export var EuiRangeLabel = ({
  children,
  disabled,
  side = 'max'
}) => {
  const classes = classNames('euiRangeLabel', `euiRangeLabel--${side}`, {
    'euiRangeLabel--isDisabled': disabled
  });
  return <label className={classes}>{children}</label>;
};
EuiRangeLabel.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired]).isRequired,
  disabled: PropTypes.bool,
  side: PropTypes.oneOf(["min", "max"])
};

try {
  // @ts-ignore
  EuiRangeLabel.displayName = "EuiRangeLabel"; // @ts-ignore

  EuiRangeLabel.__docgenInfo = {
    "description": "",
    "displayName": "EuiRangeLabel",
    "props": {
      "disabled": {
        "defaultValue": null,
        "description": "",
        "name": "disabled",
        "required": false,
        "type": {
          "name": "boolean | undefined"
        }
      },
      "side": {
        "defaultValue": {
          value: "max"
        },
        "description": "",
        "name": "side",
        "required": false,
        "type": {
          "name": "\"max\" | \"min\" | undefined"
        }
      }
    }
  }; // @ts-ignore

  if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["src/components/form/range/range_label.tsx#EuiRangeLabel"] = {
      docgenInfo: EuiRangeLabel.__docgenInfo,
      name: "EuiRangeLabel",
      path: "src/components/form/range/range_label.tsx#EuiRangeLabel"
    };
} catch (__react_docgen_typescript_loader_error) {}